import { createContext, ReactNode, useContext, useMemo } from 'react'
import { GuestChallengeAdapter } from '@/repositories/GuestChallengeAdapter'
import { UserChallengeRepository } from '@/repositories/UserChallengeRepository'

interface GuestContextType {
  challengeRepository: UserChallengeRepository
  hasGuestData: () => boolean
  getChallengeCount: () => number
  isGuestMode: boolean
}

const GuestContext = createContext<GuestContextType | undefined>(undefined)

interface GuestProviderProps {
  children: ReactNode
}

export function GuestProvider({ children }: GuestProviderProps) {
  const guestAdapter = useMemo(() => new GuestChallengeAdapter(), [])
  
  const value = useMemo(() => ({
    challengeRepository: guestAdapter,
    hasGuestData: () => guestAdapter.hasGuestData(),
    getChallengeCount: () => guestAdapter.getChallengeCount(),
    isGuestMode: true,
  }), [guestAdapter])

  return (
    <GuestContext.Provider value={value}>
      {children}
    </GuestContext.Provider>
  )
}

export function useGuest() {
  const context = useContext(GuestContext)
  if (context === undefined) {
    throw new Error('useGuest must be used within a GuestProvider')
  }
  return context
}